import "animate.css";
import { poisBountyAssets } from "assets/cdn";
import classNames from "classnames";
import DebugCopyIdButton from "debug/components/DebugCopyIdButton";
import { usePoisBountyContext } from "components/PoisBountyWidgetV3/context";
import {
	EventEndedState,
	ProgressSteps
} from "components/PoisBountyWidgetV3/lib";
import { PurchaseCounter } from "components/PoisBountyWidgetV3/lib/ProgressSteps/lib/ToShopSection/styles";
import { useAppSelector, useImagePath } from "hooks";
import { useMemo } from "react";
import { selectPoisBountyV3State } from "redux/slices";
import { InfoButton, Timer } from "../../lib/common";
import { Body, Container, Head } from "./styles";

export const InProgress = () => {
	const { getImage } = useImagePath("cdn");
	const { isPortrait, isPageVariant } = usePoisBountyContext();
	const { tracker, allRewardsCollected, trackers } = useAppSelector(
		selectPoisBountyV3State
	);
	const purchasesCount = useMemo(() => {
		return Object.values(tracker?.purchases || {})?.filter(
			(p) => p?.userId === trackers?.userData?.userId
		)?.length;
	}, [Object.keys(tracker?.purchases || {})?.length]);

	const isMaxed = useMemo(() => {
		return purchasesCount >= Number(tracker?.clubMaxPurchasesPerCycle);
	}, [purchasesCount, tracker?.clubMaxPurchasesPerCycle]);

	const headImageUrl =
		tracker?.megaMenuBackgroundImageUrl ||
		getImage(poisBountyAssets.v2.megaMenu.background);

	return (
		<Container
			color={tracker?.backgroundColorHex}
			sx={{
				minHeight: isPageVariant ? "10em" : isPortrait ? "49em" : "42em"
			}}
			className={classNames([
				isPortrait && "portrait",
				isPageVariant && "page-variant"
			])}
		>
			{!isPageVariant && (
				<Head image={headImageUrl}>
					{tracker?.clubMaxPurchasesPerCycle && (
						<PurchaseCounter isMaxed={isMaxed}>
							{purchasesCount}/{tracker.clubMaxPurchasesPerCycle}{" "}
							{tracker.clubMaxPurchasesPerCycle > 1 ? "purchases" : "purchase"}
						</PurchaseCounter>
					)}
				</Head>
			)}
			<Body eventended={allRewardsCollected ? 1 : 0}>
				{!allRewardsCollected ? <ProgressSteps /> : <EventEndedState />}
			</Body>
			{/* 🔦 Overlap components */}
			<Timer />
			<InfoButton />
			{trackers?.eventId && (
				<DebugCopyIdButton
					id={trackers.eventId}
					label="EventID"
					side="center"
					vertical="bottom"
					style={{ fontSize: "1.5em" }}
				/>
			)}
		</Container>
	);
};
